import { Globals } from '../models/Globals';
import { Person } from '../models/Person';
import { isProd } from './UtilService';

/* eslint-disable @typescript-eslint/camelcase */
interface GASettings {
    STAG: string;
    PROD: string;
}

export enum FlowEvents {
    MY_FAVORITES = 'FLW_ACESSO_MEUS_FAVORITOS',
    MY_CREATIONS = 'FLW_ACESSO_MINHAS_CRIACOES',
    MY_COMPLETED = 'FLW_ACESSO_MEUS_CONCLUIDOS',
    ACCESS_AUTHOR_PROFILE = 'FLW_ACESSO_PERFIL_AUTOR',
    LOGIN = 'FLW_NOVO_LOGIN',
    SAVE_LEARNING_MAP_MY_PROFILE = 'FLW_SALVAR_MAPA_MEU_PERFIL',
    LEARNING_MAP_COMPLETED = 'FLW_CONCLUIU_MAPA',
    ACCESS_RECOMMENDATION_ITEM_BY_EMAIL = 'FLW_ACESSO_ITEM_RECOMENDACAO_EMAIL',
    MENU_ACHIEVEMENTS = 'FLW_ACESSO_CONQUISTAS',
    ACCESS_PROFILE_PLT_COMMENT_ITEM = 'FLW_ACESSO_PERFIL_PLT_COMENTARIO_ITEM',
    ACCESS_PROFILE_LIST_FOLLOWERS_MY_PROFILE = 'FLW_ACESSO_PERFIL_LISTA_SEG_MEU_PERFIL',
    ACCESS_PROFILE_LIST_FOLLOWERS_PUB_PROFILE = 'FLW_ACESSO_PERFIL_LISTA_SEG_PERFIL_PUB',
    FOLLOW_PUB_PROFILE = 'FLW_SEGUIR_PERFIL_PUB',
    FOLLOW_LIST_PROFILE_FOLLOWERS_PUB_PROFILE = 'FLW_SEGUIR_PERFIL_LISTA_SEG_PERFIL_PUB',
    FOLLOW_LIST_FOLLOWERS_MY_PROFILE = 'FLW_SEGUIR_LISTA_SEG_MEU_PERFIL',
    EDIT_MY_PROFILE = 'FLW_EDITAR_MEU_PERFIL',
    NEW_ACCESS = 'FLW_NOVO_ACESSO',
    ACCESS_PROFILE_PLT_COMMENT_LIST = 'FLW_ACESSO_PERFIL_PLT_COMENTARIO_LISTA',
}

export enum PlaylistEvents {
    ACCESS_ITEM = 'PLT_ACESSO_ITEM',
    ACCESS_ITEM_SECTION_MY_FAVORITES = 'PLT_ACESSO_ITEM_SEC_MEUS_FAVORITOS',
    ACCESS_ITEM_SECTION_MY_CREATIONS = 'PLT_ACESSO_ITEM_SEC_MINHAS_CRIACOES',
    ACCESS_ITEM_SECTION_MY_COMPLETED = 'PLT_ACESSO_ITEM_SEC_MEUS_CONCLUIDOS',
    ACCESS_ITEM_SECTION_IN_PROGRESS = 'PLT_ACESSO_ITEM_SEC_EM_ANDAMENTO',
    ACCESS_ITEM_SECTION_MOST_ACCESSED = 'PLT_ACESSO_ITEM_SEC_MAIS_ACESSADOS',
    ACCESS_ITEM_SECTION_TOP_RATED = 'PLT_ACESSO_ITEM_SEC_MELHOR_AVALIADO',
    ACCESS_ITEM_SECTION_LAST_PUBLISHED = 'PLT_ACESSO_ITEM_SEC_ULTIMOS_PUBLICADOS',
    ACCESS_ITEM_SECTION_IN_CATEGORY = 'PLT_ACESSO_ITEM_SEC_EM_CATEGORIA_%n',
    ACCESS_ITEM_SECTION_SEARCH_RESULT = 'PLT_ACESSO_ITEM_SEC_RESULTADO_BUSCA',
    ACCESS_ITEM_SECTION_FOR_YOU = 'PLT_ACESSO_ITEM_SEC_PRA_VOCE',
    ACCESS_ITEM_SECTION_LIKE_YOU = 'PLT_ACESSO_ITEM_SEC_VC_TB_PODE_GOSTAR',
    COMMENT_ITEM = 'PLT_COMENTAR_ITEM',
    FINISH_ITEM = 'PLT_CONCLUIR_ITEM',
    FAVORITE_ITEM = 'PLT_FAVORITAR_ITEM',
    RATE_ITEM = 'PLT_NOVA_AVALIACAO_DE_ITEM',
    ADD_ITEM_ON_STUDENT_PLAYLIST = 'PLT_ITEM_ADICIONADO_A_LISTA_PRIVADA',
    REMOVE_ITEM_ON_STUDENT_PLAYLIST = 'PLT_ITEM_REMOVIDO_DA_LISTA_PRIVADA',

    ACCESS_PLAYLIST = 'PLT_ACESSO_LISTA',
    ACCESS_PLAYLIST_SECTION_MY_FAVORITES = 'PLT_ACESSO_LISTA_SEC_MEUS_FAVORITOS',
    ACCESS_PLAYLIST_SECTION_MY_CREATIONS = 'PLT_ACESSO_LISTA_SEC_MINHAS_CRIACOES',
    ACCESS_PLAYLIST_SECTION_MY_COMPLETED = 'PLT_ACESSO_LISTA_SEC_MEUS_CONCLUIDOS',
    ACCESS_PLAYLIST_SECTION_IN_PROGRESS = 'PLT_ACESSO_LISTA_SEC_EM_ANDAMENTO',
    ACCESS_PLAYLIST_SECTION_MOST_ACCESSED = 'PLT_ACESSO_LISTA_SEC_MAIS_ACESSADOS',
    ACCESS_PLAYLIST_SECTION_TOP_RATED = 'PLT_ACESSO_LISTA_SEC_MELHOR_AVALIADO',
    ACCESS_PLAYLIST_SECTION_LAST_PUBLISHED = 'PLT_ACESSO_LISTA_SEC_ULTIMOS_PUBLICADOS',
    ACCESS_PLAYLIST_SECTION_IN_CATEGORY = 'PLT_ACESSO_LISTA_SEC_EM_CATEGORIA_%n',
    ACCESS_PLAYLIST_SECTION_SEARCH_RESULT = 'PLT_ACESSO_LISTA_SEC_RESULTADO_BUSCA',
    ACCESS_PLAYLIST_SECTION_HAS_A_CONTENT = 'PLT_ACESSO_LISTA_SEC_TEM_UM_CONTEUDO',
    ACCESS_PLAYLIST_SECTION_STUDENT_PUBLISHED = 'PLT_ACESSO_LISTA_SEC_CONTEUDO_DE_USUARIO',
    FINISH_LIST_ITEM = 'PLT_CONCLUIR_ITEM_LISTA',
    FAVORITE_PLAYLIST = 'PLT_FAVORITAR_LISTA',
    RATE_PLAYLIST = 'PLT_NOVA_AVALIACAO_DE_LISTA',
    CONSUMPTION_PLAYLIST = 'PLT_CONSUMO_LISTA',
    CREATE_STUDENT_PLAYLIST = 'PLT_CRIACAO_LISTA_PRIVADA',
    DELETE_STUDENT_PLAYLIST = 'PLT_EXCLUSAO_LISTA_PRIVADA',
    PUBLISH_LIST = 'PLT_PUBLICAR_LISTA',
    COMMENT_LIST = 'PLT_COMENTAR_LISTA',
}

export enum LMSEvents {
    ACCESS_LESSON = 'LMS_ACESSO_LICAO',
    COMMENT_LESSON = 'LMS_COMENTAR_LICAO',
    FINISH_LESSON = 'LMS_CONCLUIR_LICAO',

    ACCESS_COURSE = 'LMS_ACESSO_CURSO',
    ACCESS_COURSE_SECTION_MY_FAVORITES = 'LMS_ACESSO_CURSO_SEC_MEUS_FAVORITOS',
    ACCESS_COURSE_SECTION_MY_COMPLETED = 'LMS_ACESSO_CURSO_SEC_MEUS_CONCLUIDOS',
    ACCESS_COURSE_SECTION_ESSENTIALS = 'LMS_ACESSO_CURSO_SEC_ESSENCIAIS',
    ACCESS_COURSE_SECTION_IN_PROGRESS = 'LMS_ACESSO_CURSO_SEC_EM_ANDAMENTO',
    ACCESS_COURSE_SECTION_MOST_ACCESSED = 'LMS_ACESSO_CURSO_SEC_MAIS_ACESSADOS',
    ACCESS_COURSE_SECTION_TOP_RATED = 'LMS_ACESSO_CURSO_SEC_MELHOR_AVALIADO',
    ACCESS_COURSE_SECTION_LAST_PUBLISHED = 'LMS_ACESSO_CURSO_SEC_ULTIMOS_PUBLICADOS',
    ACCESS_COURSE_SECTION_IN_CATEGORY = 'LMS_ACESSO_CURSO_SEC_EM_CATEGORIA_%n',
    ACCESS_COURSE_SECTION_SEARCH_RESULT = 'LMS_ACESSO_CURSO_SEC_RESULTADO_BUSCA',
    FAVORITE_COURSE = 'LMS_FAVORITAR_CURSO',
    RATE_COURSE = 'LMS_NOVA_AVALIACAO_DE_CURSO',
    CONSUMPTION_COURSE = 'LMS_CONSUMO_CURSO',
    FINISH_COURSE = 'LMS_CONCLUIR_CURSO',

    ACCESS_PROGRAM = 'LMS_ACESSO_TRILHA',
    ACCESS_PROGRAM_SECTION_MY_FAVORITES = 'LMS_ACESSO_TRILHA_SEC_MEUS_FAVORITOS',
    ACCESS_PROGRAM_SECTION_MY_COMPLETED = 'LMS_ACESSO_TRILHA_SEC_MEUS_CONCLUIDOS',
    ACCESS_PROGRAM_SECTION_IN_PROGRESS = 'LMS_ACESSO_TRILHA_SEC_EM_ANDAMENTO',
    ACCESS_PROGRAM_SECTION_MOST_ACCESSED = 'LMS_ACESSO_TRILHA_SEC_MAIS_ACESSADOS',
    ACCESS_PROGRAM_SECTION_TOP_RATED = 'LMS_ACESSO_TRILHA_SEC_MELHOR_AVALIADO',
    ACCESS_PROGRAM_SECTION_LAST_PUBLISHED = 'LMS_ACESSO_TRILHA_SEC_ULTIMOS_PUBLICADOS',
    ACCESS_PROGRAM_SECTION_IN_CATEGORY = 'LMS_ACESSO_TRILHA_SEC_EM_CATEGORIA_%n',
    ACCESS_PROGRAM_SECTION_SEARCH_RESULT = 'LMS_ACESSO_TRILHA_SEC_RESULTADO_BUSCA',
    FAVORITE_PROGRAM = 'LMS_FAVORITAR_TRILHA',
    RATE_PROGRAM = 'LMS_NOVA_AVALIACAO_DE_TRILHA',
    FINISH_PROGRAM = 'LMS_CONCLUIR_TRILHA',
    ACCESS_COURSE_INSIDE_PROGRAM = 'LMS_ACESSO_CURSO_DA_TRILHA',
    ACCESS_COURSE_SECTION_TRAINING = 'LMS_ACESSO_CURSO_SEC_TREINAMENTOS',
    ACCESS_PROGRAM_SECTION_TRAINING = 'LMS_ACESSO_TRILHA_SEC_TREINAMENTOS',
    ACCESS_COURSE_BY_EMAIL = 'LMS_ACESSO_CURSO_EMAIL',
}

export enum BotEvents {
    SAVE_LEARNING_MAP_CHAT = 'BOT_SALVAR_MAPA_CHAT',
    ACCESS_ITEM_RECOMMENDATION_CHAT = 'BOT_ACESSO_ITEM_RECOMENDACAO_CHAT',
    FAVORITE_ITEM_CHAT = 'BOT_FAVORITAR_ITEM',
}

class AnalyticsService {
    private GA_ID: GASettings = { STAG: 'G-5KV6YKVRZJ', PROD: 'G-KSM6Q5VV61' };
    private gTag: CallableFunction = ((window as unknown) as Globals).gtag;

    initialize = () => {
        this.gTag('js', new Date());
        this.gTag('config', this.getMeasurementID());
    };

    setUserProperties = (person: Person): void => {
        this.gTag('set', 'user_properties', {
            organization: person.orgId.toString(),
            person: person.id && person.id.toString(),
        });
    };

    setUserId = (person: Person): void => {
        this.gTag('set', { user_id: `${person.applicationId}.${person.orgId}.${person.id}` });
    };

    setUserPropertiesConfiguration = (person: Person) => {
        if (person) {
            this.setUserProperties(person);
            this.setUserId(person);
        }
    };

    logEvent = (name: string, params?: { [key: string]: string | number | undefined }) => {
        this.gTag('event', name, params);
    };

    setCurrentScreen = (pageName: string) => {
        this.gTag('event', 'screen_view', {
            screen_name: pageName,
        });
    };

    getMeasurementID = (): string => {
        return isProd() ? this.GA_ID.PROD : this.GA_ID.STAG;
    };
}

export const analyticsService = new AnalyticsService();
